import { Button, Dimmer, Header, Icon, Loader, Menu, Message } from '@mairistem/composants';
import { request } from '@mairistem/tools';
import React from 'react';
import { toast } from 'react-toastify';
import { postRegieProduction } from '@/routes';
import type { RegieType } from '@/types';
import { ModalConfirm } from '../Autre';

type ModalRegieEcoleVersProductionProps = {
  disabled?: boolean;
  regie: RegieType;
  onConfirm?: (regie: RegieType) => void;
};

const ModalRegieEcoleVersProduction = (props: ModalRegieEcoleVersProductionProps) => {
  const { disabled, regie, onConfirm } = props;

  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleConfirm = React.useCallback(() => {
    setLoading(true);

    request
      .post(postRegieProduction(regie.identifiant))
      .then((updatedRegie: RegieType) => {
        setLoading(false);
        setOpen(false);

        onConfirm(updatedRegie);

        toast(
          <Header style={{ width: 320 }}>
            Mise en production réussie
            <Header.Subheader style={{ marginTop: 8 }}>
              {regie?.titre} est en production.
            </Header.Subheader>
          </Header>,
          { type: 'success' },
        );
      })
      .catch(() => {
        setLoading(false);

        toast('Erreur lors de la mise en production', { type: 'error' });
      });
  }, [onConfirm, regie]);

  return (
    <>
      <Menu.Item
        as={Button}
        data-testid="button-regie-en-production"
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        <Icon name="rocket" style={{ paddingRight: 25 }} />
        Passer la régie en production
      </Menu.Item>
      {open && (
        <ModalConfirm
          size="small"
          loading={loading}
          content={
            <div style={{ height: 150 }}>
              {loading ? (
                <Dimmer active={loading} inverted>
                  <Loader inverted>
                    Suppression des données en cours.
                    <br />
                    <br />
                    L&apos;opération peut prendre quelques minutes.
                  </Loader>
                </Dimmer>
              ) : (
                <>
                  <Header as="h4">
                    <Header.Content>
                      La mise en production de la régie déclenche la procédure de remise à zéro du
                      travail d&apos;encaissement réalisé lors de la phase d&apos;apprentissage.
                    </Header.Content>
                  </Header>
                  <Message info size="small">
                    <Message.Header>Cette action est irréversible.</Message.Header>
                    <Message.Content>
                      <br />
                      Cycles, imputations, factures et reçus seront supprimés.
                      <br />
                      Toutes les saisies liées au paramétrage de l&apos;application seront
                      conservées.
                    </Message.Content>
                  </Message>
                </>
              )}
            </div>
          }
          onCancel={() => setOpen(false)}
          onConfirm={handleConfirm}
          confirmText="Confirmer"
          cancelText="Annuler"
          header={<>Mise en production de : {regie?.titre}</>}
        />
      )}
    </>
  );
};

export default ModalRegieEcoleVersProduction;
